module.exports = __webpack_public_path__ + "static/media/izzy.9d83a73d.jpg";